module.exports = __webpack_public_path__ + "dashboard/img/dropdown-12.acf196909352ab20183fc9d69b1e0d51.svg";